/* Capture first-touch acquisition source on initial visit.
 * Stored once in localStorage; never overwritten on subsequent visits.
 */
const KEY = "alternavit_source_v1";

function referrerDomain(refUrl) {
  if (!refUrl) return null;
  try {
    return new URL(refUrl).hostname.replace(/^www\./, "");
  } catch {
    return null;
  }
}

export function captureSourceOnce() {
  if (typeof window === "undefined") return;
  if (localStorage.getItem(KEY)) return;
  const params = new URLSearchParams(window.location.search);
  const source = {
    referrer: document.referrer || null,
    referrer_domain: referrerDomain(document.referrer),
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    utm_content: params.get("utm_content") || null,
    utm_term: params.get("utm_term") || null,
    landing_path: window.location.pathname,
    first_seen_at: new Date().toISOString(),
  };
  localStorage.setItem(KEY, JSON.stringify(source));
}

export function getStoredSource() {
  if (typeof window === "undefined") return null;
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}
